var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHdStreaming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#10ACE3",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F9F9F9",
    fillRule: "nonzero",
    width: 76,
    height: 76,
    rx: 38
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.916 32.343 4.644 2.71a.485.485 0 0 1 0 .834l-4.644 2.71a.475.475 0 0 1-.713-.416v-5.422c0-.37.396-.602.713-.416zM33.691 44.301h12.464M28 24.829h19.653M28 50.045h19.865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 25.305V54.99c0 1.11-.89 2.01-1.989 2.01H29.99C28.89 57 28 56.1 28 54.99V22.02a2 2 0 0 1 1.989-2.009h12.32M31.775 43.602v1.463M29.845 43.602v1.463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.999 25.883V22.01c0-1.11-.89-2.01-1.988-2.01h-5.65M35.919 53.495h4.044"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdStreaming);
export default __webpack_public_path__ + "static/media/HD-streaming.f38efc5cd457ef1f78aa404f9fee29c8.svg";
export { ForwardRef as ReactComponent };